import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import cn from "classnames";
import { FaWhatsapp } from "react-icons/fa";

import { Shipment } from "services/action";

import {
  Page,
  DetailShipmentCard,
  MapBox,
  LoadingScreen,
  DeniedScreen,
} from "ui/components";

import { formatDate, waFormat } from "utilities/common";

const DetailShipment = ({ match, location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services["Shipment.Show"]
  );

  const [denied, setDenied] = React.useState(false);
  const [data, setData] = React.useState(null);

  const $onLoad = async (id) => {
    const req = await Dispatch(Shipment.$show(id));

    if (req?.message === "success") {
      if (req?.data !== null) {
        setData(req?.data);
      } else {
        setDenied(true);
      }
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  if (StateLoading) {
    return <LoadingScreen />;
  }

  if (denied) {
    return <DeniedScreen />;
  }

  const ListHorizontal = ({ title, content, className }) => {
    const c = cn(
      className ? className : "",
      "row py-1 mb-1 list-item m-0 align-items-start fsz-12 border-bottom"
    );

    return (
      <div className={c}>
        <div className="col-4 p-0 fsz-12">{title}</div>
        <div className="col-1 p-0 fsz-12">:</div>
        <div className="col-7 p-0 text-start title fsz-12">{content}</div>
      </div>
    );
  };

  const Action = () => {
    return (
      <div>
        <div className="row mb-2">
          <div className="col-4">
            <Button
              type="button"
              variant="primary"
              className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
              onClick={() =>
                History.push({
                  pathname: "/pod",
                  state: {
                    shipment_id: data?.id,
                    code: data?.code,
                    type: "shipment-console",
                  },
                })
              }
            >
              Transit
            </Button>
          </div>
          <div className="col-4">
            <Button
              type="button"
              variant="success"
              className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
              onClick={() =>
                History.push({
                  pathname: "/pod",
                  state: {
                    shipment_id: data?.id,
                    code: data?.code,
                    type: "shipment-delivered",
                  },
                })
              }
            >
              Delivered
            </Button>
          </div>
          <div className="col-4">
            <Button
              type="button"
              variant="danger"
              className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
              onClick={() =>
                History.push({
                  pathname: "/pod",
                  state: {
                    shipment_id: data?.id,
                    code: data?.code,
                    type: "shipment-disputed",
                  },
                })
              }
            >
              Disputed
            </Button>
          </div>
        </div>
      </div>
    );
  };

  const renderMap = () => {
    let map = null;

    map = <MapBox destination={data?.destination} data={data} />;
    return map;
  };

  return (
    <Page
      title={`Detail Shipment`}
      backTo={() => History.goBack()}
      action={<Action />}
    >
      <div>{renderMap()}</div>
      <div className="py-2 pb-5">
        <DetailShipmentCard title="Informasi Pengiriman">
          <ListHorizontal
            title="Kode Pengiriman"
            content={<div style={{ fontWeight: "bold" }}>{data?.code}</div>}
          />
          {data?.manifest_active ? (
            <ListHorizontal
              title="Kode Manifest"
              content={
                <div style={{ fontWeight: "bold" }}>
                  {data?.manifest_active?.code}
                </div>
              }
            />
          ) : null}
          {data?.ref_code ? (
            <ListHorizontal
              title="Kode Referensi"
              content={
                <div style={{ fontWeight: "bold" }}>{data?.ref_code}</div>
              }
            />
          ) : null}
          {data?.tracking_code ? (
            <ListHorizontal
              title="Kode Pelacakan"
              content={
                <div style={{ fontWeight: "bold" }}>{data?.tracking_code}</div>
              }
            />
          ) : null}

          <ListHorizontal
            title="ETA"
            content={formatDate(data?.eta_at, "DD/MM/YYYY")}
          />

          {data?.instruction && (
            <ListHorizontal
              title="Instruksi Pengiriman"
              content={data?.instruction}
            />
          )}
        </DetailShipmentCard>

        {data?.shipper ? (
          <DetailShipmentCard title="Shipper">
            <ListHorizontal
              title="Nama"
              content={
                <div>
                  <div style={{ fontWeight: "bold" }}>
                    {data?.shipper?.name}
                  </div>
                  <div style={{ alignItems: "baseline", marginVertical: 5 }}>
                    <div>{data?.shipper?.phone}</div>
                  </div>
                  <div
                    className="badge bg-success text-white px-3"
                    onClick={() =>
                      window.open(
                        `https://wa.me/${waFormat(data?.shipper?.phone)}`,
                        "_blank"
                      )
                    }
                  >
                    <div className="d-flex align-items-center flex-row py-3">
                      <FaWhatsapp size={15} />
                      <div>Contact</div>
                    </div>
                  </div>
                </div>
              }
            />
            <ListHorizontal
              title="Alamat"
              content={
                <div style={{ fontWeight: "bold" }}>
                  {data?.shipper?.address || "-"}
                </div>
              }
            />
          </DetailShipmentCard>
        ) : null}

        {data?.destination ? (
          <DetailShipmentCard title="Tujuan">
            <ListHorizontal
              title="Nama"
              content={
                <div>
                  <div style={{ fontWeight: "bold" }}>
                    {data?.destination?.name}
                  </div>
                  <div style={{ alignItems: "baseline", marginVertical: 5 }}>
                    <div>{data?.destination?.phone_number}</div>
                  </div>
                  <div
                    className="badge bg-success text-white px-3"
                    onClick={() =>
                      window.open(
                        `https://wa.me/${waFormat(
                          data?.destination?.phone_number
                        )}`,
                        "_blank"
                      )
                    }
                  >
                    <div className="d-flex align-items-center flex-row py-3">
                      <FaWhatsapp size={15} />
                      <div>Contact</div>
                    </div>
                  </div>
                </div>
              }
            />
            <ListHorizontal
              title="Alamat"
              content={
                <div>
                  <div style={{ fontWeight: "bold" }}>
                    {data?.destination?.address}
                  </div>
                  <div>
                    {data?.destination?.region?.village_name},{" "}
                    {data?.destination?.region?.district_name},{" "}
                    {data?.destination?.region?.regency_name},{" "}
                    {data?.destination?.region?.province_name}
                  </div>
                </div>
              }
            />
          </DetailShipmentCard>
        ) : null}

        {/* end of section khusus buat manifest tipe trucking */}

        {data?.items ? (
          <DetailShipmentCard title="Detil Barang">
            <div className="py-2">
              <div className="table-responsive mb-0">
                <table
                  width="100%"
                  className="table table-hover table-vcenter card-table datatable border rounded"
                >
                  <thead className="bg-light">
                    <tr className="th">
                      <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                        Nama Barang
                      </td>
                      <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                        Koli
                      </td>
                      <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                        Berat (Kg)
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.items?.map((d, i) => (
                      <tr key={i}>
                        <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                          {d?.item_name}
                        </td>
                        <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                          {d?.quantity}
                        </td>
                        <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                          {d?.weight}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </DetailShipmentCard>
        ) : null}
      </div>
    </Page>
  );
};

export default DetailShipment;
